<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Communication & Networking </template>
    <template #description>
      Quantum technologies could revolutionize communication and networking by providing secure communication channels through quantum encryption, ensuring that sensitive data remains protected. They will enable faster and more reliable data transmission, improving global connections and access to information through advanced quantum networks. Additionally, quantum innovations could enhance the security of online transactions, offering a safer digital environment for financial exchanges and personal communications. These advancements will pave the way for a more connected and secure digital world.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Communication & Networking" />
    </template>
  </LImpact>
</template>

<style scoped></style>
